import React from 'react'
import Testimonial from './components/Testimonial'
import TestimonialHero from './components/TestimonialHero'

const Testimonials = () => {
  return (
    <div>
        <div class="mt-5">
             <Testimonial/>
       </div>
     
        
    </div>
  )
}

export default Testimonials
